import axios from 'axios'
import router from '../../router'

const state = {
  receiptNumber: '',
  myPostValues: {},
  fileName: '',
  fileId: 0,
  postId: 0
}

const mutations = {
  setReceiptInfo (state, payload) {
    state.receiptNumber = payload.receiptNumber
  },
  setMyPostValues (state, payload) {
    state.myPostValues = payload
    state.postId = payload.id
  },
  setAddComments (state, payload) {
    state.myPostValues.comments.push(payload)
  },
  setAttachFileUser (state, payload) {
    state.fileId = payload.id
    state.fileName = payload.clientFilename
  }
}

const getters = {
  getReceiptNumber: state => {
    return state.receiptNumber
  },
  getMyPostValues: state => {
    return state.myPostValues
  },
  getPostIdUser (state) {
    return state.postId
  },
  getPostFileIdUser (state) {
    return state.fileId
  },
  getPostFilename (state) {
    let temp = state.fileName.split('/')
    state.fileName = temp[temp.length - 1]
    return state.fileName
  },
  getUserPostStatus (state) {
    return state.myPostValues.statusCode
  }
}

const actions = {
  apiInformantPosts (context, payload) {
    axios.post('/api/informant/posts', payload)
      .then((response) => {
        context.commit('setReceiptInfo', response.data)
        router.push('/reportcomplete')
      })
      .catch((error) => {
        alert(error.response.data.message)
      })
  },
  apiInformantPostsSendmail (context, payload) {
    axios.post('/api/informant/posts/sendmail', payload)
      .then((response) => {
        router.push('/reportcomplete')
      })
      .catch((error) => {
        alert(error.response.data.message)
      })
  },
  apiInformantInform (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      axios.get('/api/informant/posts/mypost')
        .then((response) => {
          context.commit('setMyPostValues', response.data)
          if (response.data.attachFiles[0] !== undefined) {
            context.commit('setAttachFileUser', response.data.attachFiles[0])
          }
        })
        .catch((error) => {
          alert(error.response.data.message)
          if (error.response.status === 410) {
            sessionStorage.removeItem('token')
            router.push('/reportinquiry')
          }
        })
    } else {
      alert('세션 만료 또는 잘못된 접근 입니다.')
      router.push('/reportinquiry')
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/imformant.js